import React, { HTMLAttributes } from 'react';
import s from './SectionWrapper.module.scss';

interface SectionWrapperProps extends HTMLAttributes<HTMLElement> {
  sectionId: string;
  children: any;
}

const SectionWrapper = React.forwardRef(
  (props: SectionWrapperProps, ref: any) => {
    const { sectionId, children, ...restProps } = props;
    return (
      <section
        id={sectionId}
        tabIndex={-1}
        ref={(el) => {
          if (ref?.current) {
            ref.current[sectionId] = el;
          }
        }}
        className={s.navigationSection}
        {...restProps}
      >
        {children}
      </section>
    );
  },
);

export default SectionWrapper;
